<template>
  <img class="banner-image" src="../assets/toppic/图片-03.jpg"/>
  <div class="panel-div">

    <div class="title-panel-name">
      <div class="item-group-div"  v-for="(item,index) in customerGroupList" :key="item.id">
        <router-link class="item-group-div" :to="'/customercase/'+item.id" :underline="false">
          <span :class="{'panel-span active':activeName == item.groupName,'panel-span':activeName != item.groupName,}" >{{item.groupName}}</span>
          <span v-if="index < customerGroupList.length -1">|</span>
        </router-link>
      </div>
    </div>


    <el-row v-if="companyinfoList && companyinfoList.length > 0">
      <el-col  :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-for="item in companyinfoList" :key="item.title">
        <router-link :underline="false" :to="'/customercasedetial/'+item.id" style="text-decoration: none;">
          <div class="archive-info">
            <img :src="item.coverImage" />
            <div class="content-body">
              <p class="p-title">{{truncateStr(item.title,60)}}</p>
              <p class="p-descrption">{{truncateStr(item.summary,200)}}</p >
            </div>
          </div>
        </router-link>

      </el-col>
    </el-row>
    <el-row>
      <el-col  v-if="!companyinfoList || companyinfoList.length == 0">
        <el-empty :description="locale[language.code].companynews.emptyTips"></el-empty>
      </el-col>
    </el-row>

    <!--    <pagination-->
    <!--        v-show="total>0"-->
    <!--        :total="total"-->
    <!--        :page.sync="queryParams.pageNum"-->
    <!--        :limit.sync="queryParams.pageSize"-->
    <!--        @pagination="getList"-->
    <!--    />-->
    <el-pagination
        class="archive-pages"
        background
        @current-change="changePage"
        layout="prev, pager, next"
        :total="total">
    </el-pagination>

  </div>

</template>

<script>
import{ customizedsolution,customergroup } from "@/api/CustomerCase";
import { truncateStr } from "@/utils/ruoyi";
import locale from "@/locale/locale";


export default {
  name: 'CustomerCase',

  props: {
    msg: String
  },
  data(){
    return {
      locale:locale,
      language:null,
      activeIndex:null,
      companyinfoList:[],
      customerGroupId:null,
      customerGroupList:[],
      activeName:null,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        title: null,
        languageId: null,
      },
    }
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    var languageStr = localStorage.getItem("website-language");

    if(!languageStr){
      var intervalIndex = setInterval(() =>{
        var languageStr = localStorage.getItem("website-language");
        if(languageStr){
          clearInterval(intervalIndex);
          this.language = JSON.parse(languageStr);
          this.initData();
        }
      },100);
    }else{
      this.language = JSON.parse(languageStr);
      this.initData();
    }
  },
  methods: {
    truncateStr(str,length){
      return truncateStr(str,length);
    },
    initData() {
      this.queryParams.languageId = this.language.id;
      console.log(this.$route)
      this.customerGroupId = this.$route.params.id;
      customergroup({id:this.language.id}).then(res => {
        console.log(res);
        this.customerGroupList = res.data;

        for(var tempIndex in this.customerGroupList){
          if(this.customerGroupList[tempIndex].id == this.customerGroupId){
            this.activeName = this.customerGroupList[tempIndex].groupName;
            this.activeIndex = tempIndex;
          }
        }
      });
      this.getCustomerSolutionData();
    },
    getCustomerSolutionData(){

      var data = {
        languageId:this.language.id,
        customerGroupId:this.customerGroupId
      };
      customizedsolution(data).then(res => {
        console.log(res);
        this.companyinfoList = res.rows;
        this.total = res.total;
        if(this.companyinfoList.length > 0){
          this.activeName = this.companyinfoList[0].title;
        }
      });
    },
    changePage(target){
      console.log(target)
      // this.queryParams.pageNum = pageNum;
      // this.initData();
    },
    changePanel(index) {
      this.activeName = this.companyinfoList[index].title;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.panel-div{
  padding:20px 35px;
  margin:20px 20px;
  text-align: left;
}

.archive-info{
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin: 10px 10px;
  background: #F6F6F6;
  padding:12px 16px;
  border-radius: 6px;
}

.archive-info img{
  width:100px;
}

.archive-info .content-body{
  margin-left: 10px;
}

@media (max-width: 720px) {

  .panel-div{
    padding:20px 0px!important;
    margin:20px 5px!important;
  }
}

.archive-info .content-body .p-title{
  font-weight: 600;
  margin-bottom: 10px;
  color:#101010;
  text-decoration: none;
}

.archive-info .content-body .p-descrption{
  font-size: 13px;
  text-decoration: none;
  color:#303133;
}

.archive-pages{
  justify-content: center;
  margin:25px 20px;
  text-decoration: none;
}

.panel-div .title-panel-name{
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  width:auto;
  overflow-x: scroll;
  padding:0px 10px;
  scrollbar-width: thin; /* auto | thin | none */
  scrollbar-color: #4CAF50 #f1f1f1; /* 滑块颜色 轨道颜色 */
  margin:20px 0px;
  margin-bottom: 60px;
}

.title-panel-name::-webkit-scrollbar {
  height:2px;
}

.title-panel-name::-webkit-scrollbar-thumb {
  background: #E1E1E1;
  border-radius: 3px;
}

@media (max-width: 720px) {
  .panel-div .title-panel-name {
    justify-content: flex-start!important;
  }
}

.panel-div .title-panel-name .panel-span{
  display: inline-block;
  background-color: #EFEFEF;
  white-space: nowrap;
  margin:6px 13px;
  padding:8px 18px;
  border-radius: 3px;
  cursor: pointer;
  font-weight: 600;
  color:#303133;
}

.item-group-div{
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}

.panel-div .title-panel-name .panel-span:hover{
  font-weight: 700;
  color:#1890ff;
  background-color:#e9f4ff;
}
.panel-div .title-panel-name .active{
  font-weight: 700;
  color:#1890ff;
  background-color:#e9f4ff;
}


</style>
